import React from "react";
import { Image } from "react-bootstrap";
import logo from "../../assets/images/logo.png";

export const DAADLogo = ({ iconOnly }) => (
  <div id="logo">
    <Image height={56} width={56} src={logo} className="d-inline-block" />
    {!iconOnly && (
      <p className="d-inline-block align-middle ms-2 mb-0">
        Deutscher Akademischer Austauschdienst <br />
        German Academic Exchange Service
      </p>
    )}
  </div>
);
